import React from 'react';
import './Expert.scss';
import SectionTitle from '../../../../components/SectionTitle/SectionTitle';
import { BsFillCheckCircleFill } from "react-icons/bs";

type ExpertProps = {
    label: string,
    title: string,
    description: string,
    list?: string[]
    photo: string
}

const Expert = ({label, title, description, list, photo}: ExpertProps) => {
    return (
        <section className='section-common expert-section section-m section-p'  data-aos="fade-up" data-aos-duration="1000">
            <div className="container">
            <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="expert-text">
                            <SectionTitle 
                                subTitle={label}
                                title={title}
                                description={description}
                            />

                            <ul>
                                {list && list.map((item, index) => (
                                    <li key={index}>
                                        <BsFillCheckCircleFill />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="expert-img">
                            <img src={photo} alt="zdjęcie specjalisty" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Expert;